import React, { useEffect, useState } from 'react';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import FrontLoader from '../layout/FrontLoader';
import { getFromStorage } from '../../utils/Helper';
import { StorageConstant } from '../../constants/Constants';
import { LanguageConstants } from '../../constants/LanguageConstants';
import LandingMarketingNav from '../home/LandingMarketingNav';
import Footer from '../home/Footer';
import '../home/landing.scss';
import '../cms/Cms.scss';
import './Faq.scss';

function Faq() {
  const FaqList = useMakeRequest();
  const [data, setData] = useState([]);
  const Lang = getFromStorage({ key: 'Translate' });
  const hasAccessToken = Boolean(getFromStorage({ key: StorageConstant?.ACCESS_TOKEN }));

  useEffect(() => {
    const payload = {
      user_type: 1,
      lang_id: Lang == 'spa' ? '2' : '1',
    };
    FaqList.makeRequest({ payload, url: ApiConstants?.Faqlist, toastStatus: false });
  }, []);

  useEffect(() => {
    if (FaqList?.status) {
      setData(FaqList?.data?.data);
    }
  }, [FaqList?.status]);

  return (
    <div className={`landing-page faq-page cms-page${hasAccessToken ? ' landing-page--app-header' : ''}`}>
      {!hasAccessToken ? <LandingMarketingNav /> : null}
      {FaqList?.loading ? <FrontLoader /> : null}

      <main className="d-flex justify-content-center">
        <section className="landing-section landing-about sec-y-space sec-bg w-100">
          <div className="container">
            <span className="sec-ttl mb-4 text-capitalize">{LanguageConstants?.FAQS}</span>

            <div className="accordion faq-page__accordion z-10 position-relative" id="faqExample">
              {data.length > 0 &&
                data.map((res: any, i: number) => (
                  <div className="accordion-item" key={i}>
                    <h2 className="accordion-header" id={`heading${i}`}>
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${i}`}
                        aria-expanded="true"
                        aria-controls={`collapse${i}`}
                      >
                        {res?.faqs_details?.question}
                      </button>
                    </h2>
                    <div
                      id={`collapse${i}`}
                      className={`accordion-collapse collapse ${i === 0 ? 'show' : ''}`}
                      aria-labelledby={`heading${i}`}
                      data-bs-parent="#faqExample"
                    >
                      <div className="accordion-body">{res?.faqs_details?.answer}</div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Faq;
